import { FC } from 'react';

import { useTranslation } from 'react-i18next';
import { RecoilRoot, useRecoilState } from 'recoil';

import { CAPPLAN_TABS } from './enums';

import { activeTabAtom, formationTabAtom, scenarioBarOpenAtom } from './atoms';

import { Box, Tab, Tabs } from '@mui/material';

import { TabPanel } from 'components/shared';
import StyledTabs from 'components/shared/StyledTabs';

import ScenarioBar from './components/Scenario/ScenarioBar';

import BorrowAndLending from './Formation/BorrowAndLending/BorrowAndLending';
import FlexForecast from './Formation/FlexForecast/FlexForecast';
import FormationTab from './Formation/FormationTab';
import GrossNetHoursCalculation from './Formation/GrossNet/GrossNetHoursCalculation';
import WorkDemandTab from './WorkDemand/WorkDemandTab';
import AnalyzerTab from './analyzer/Analyzer';
import BaseplanTab from './baseplan/BaseplanTab';
import { StyledStickyPaper } from 'components/shared/Paper/StyledStickyPaper';

const CapacityPlan: FC = () => {
  const { t } = useTranslation('common');
  const [, setScenarioBarOpen] = useRecoilState(scenarioBarOpenAtom);
  const [activeTab, setActiveTab] = useRecoilState(activeTabAtom);
  useRecoilState(formationTabAtom);

  const onChangeActiveTab = (e, newValue: number) => {
    setScenarioBarOpen(false);
    setActiveTab(newValue);
  };

  const setTabActiveByName = (name: keyof typeof CAPPLAN_TABS) => {
    const tab = Object.values(CAPPLAN_TABS).findIndex((val) => val === name);
    setActiveTab(tab);
  };

  return (
    <>
      <StyledTabs>
        <StyledStickyPaper square>
          <Tabs
            indicatorColor="primary"
            textColor="primary"
            value={activeTab}
            onChange={onChangeActiveTab}
          >
            {Object.values(CAPPLAN_TABS).map((tab, idx) => (
              <Tab key={tab} label={t(`capacityPlanTabs.${tab}`)} value={idx} />
            ))}
          </Tabs>
        </StyledStickyPaper>
        <ScenarioBar />
        <Box position="relative" p={2}>
          <TabPanel
            index={0}
            value={activeTab}
            title={t('capacityPlanTabs.OVERVIEW')}
          >
            <AnalyzerTab showDetailsSubTab={setTabActiveByName} />
          </TabPanel>
          <TabPanel
            index={1}
            value={activeTab}
            title={t('capacityPlanTabs.WORK_DEMAND')}
          >
            <WorkDemandTab />
          </TabPanel>
          <TabPanel
            index={2}
            value={activeTab}
            title={t('capacityPlanTabs.BASE_PLAN')}
          >
            <BaseplanTab />
          </TabPanel>
          <TabPanel
            index={3}
            value={activeTab}
            title={t('capacityPlanTabs.FORMATION')}
          >
            <FormationTab />
          </TabPanel>
          <TabPanel
            index={4}
            value={activeTab}
            title={t('capacityPlanTabs.FLEX_FORECAST')}
          >
            <FlexForecast />
          </TabPanel>
          <TabPanel
            index={5}
            value={activeTab}
            title={t('capacityPlanTabs.BORROW_AND_LEND')}
          >
            <BorrowAndLending />
          </TabPanel>
          <TabPanel
            index={6}
            value={activeTab}
            title={t('capacityPlanTabs.GROSS_NET')}
          >
            <GrossNetHoursCalculation />
          </TabPanel>
        </Box>
      </StyledTabs>
    </>
  );
};

const CapacityPlanContainer = (props) => (
  <RecoilRoot>
    <CapacityPlan {...props} />
  </RecoilRoot>
);

export default CapacityPlanContainer;
